import { useEffect, useRef, useState, RefObject } from 'react';

import { useRect } from 'hooks/useRect';

export function useRevertMenu(anchorRef: RefObject<Element>) {
  const menuRef = useRef(null);
  const { top, left, width } = useRect(anchorRef);
  const menuRect = useRect(menuRef);
  const [isReverted, setIsReverted] = useState(false);
  const [rect, setRect] = useState({ top, left, width });

  useEffect(() => {
    if (menuRect.bottom > window.innerHeight) {
      rect.top = top - menuRect.height;

      setIsReverted(true);
      setRect({ ...rect, top: top - menuRect.height });
    }
  }, [menuRect, top]);

  return {
    menuRef,
    menuStyles: {
      top: rect.top + 'px',
      left: rect.left + 'px',
      width: rect.width + 'px',
    },
    isReverted,
  };
}
